import { ManifestationOfflineDataFetcher } from '@skinsoft/data-store';
import { EntityDataStore } from '@skinsoft/entity-data-store';
import { API_ENDPOINTS } from '../..';

export interface Manifestation {
    id: string;
    type: string;
}

export class ManifestationDataStore extends EntityDataStore<Manifestation> {
    public static getInstance() {
        if (!ManifestationDataStore.instance) {
            ManifestationDataStore.instance = new ManifestationDataStore();
        }

        return ManifestationDataStore.instance;
    }

    public static install(Vue) {
        Vue.prototype.$manifestationDataStore = ManifestationDataStore.getInstance();
    }

    private static instance: ManifestationDataStore = null as any;

    constructor() {
        super('manifestations');
    }

    public update(id: string, body: Partial<Manifestation>, endpointOverride?: string) {
        return super.update(id, body, endpointOverride || API_ENDPOINTS[body.type as string])
    }

    protected initializeDataFetcher() {
        this.offlineDataFetcher = new ManifestationOfflineDataFetcher("items");
    }
}
